export const STRIPE_PUBLIC_KEY_DEV = 'pk_test_j0S0dlPafPlGsJRJSTkl4OcU00950hzknh'
export const STRIPE_PUBLIC_KEY_PROD = 'pk_live_51I8plOF7C3DGbxUVFauydcwL4RN6flf7pbY5kMeQSjBYqgargZwEVsLw2teTXeYTRzxLDOwVTcxcSXzu3ppdEBAg008axkpW3n'
export const STRIPE_PLAN_ID_DEV = 'plan_H52Tm3lVtNDTfG'
export const STRIPE_PLAN_ID_PROD = 'price_1I8r2sF7C3DGbxUVij1XfPaA'
